import { GraduationCap, Clock, Sparkles, MessageCircle, ArrowRight } from "lucide-react";
import { ACADEMY_COURSES } from "@/data/salonData";
import { openWhatsApp, bookServiceMessage } from "@/lib/whatsapp";
import { Reveal } from "@/lib/useReveal";

export default function Academy() {
  return (
    <section
      id="academy"
      data-testid="academy-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-[#2a1b18]">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-radial from-[#d4af37]/15 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-gradient-radial from-[#d98a99]/15 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <Reveal className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/20 mb-5">
            <GraduationCap size={14} className="text-[#d4af37]" />
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#d4af37] font-semibold">
              Anshi's Makeup Academy
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white font-medium leading-tight">
            Start Your <span className="text-gradient-gold italic">Professional</span>
            <br />
            Beauty Career
          </h2>
          <p className="mt-5 text-white/70 text-base md:text-lg">
            Hands-on training. Real models. Industry-certified curriculum.
            Become the makeup artist every bride dreams of.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {ACADEMY_COURSES.map((c, i) => (
            <Reveal key={c.name} delay={i * 120}>
              <div
                data-testid={`course-card-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`relative rounded-3xl p-7 h-full flex flex-col transition-all duration-500 ${
                  c.featured
                    ? "bg-gradient-to-b from-white to-[#fff5f8] text-[#2a1b18]"
                    : "bg-white/5 backdrop-blur border border-white/10 text-white hover:bg-white/8"
                }`}
              >
                {c.featured && (
                  <div className="absolute -top-3 left-7 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em] font-bold bg-[#d4af37] text-[#2a1b18]">
                    Bestseller
                  </div>
                )}
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-4 ${
                    c.featured
                      ? "bg-gradient-to-br from-[#f9d0da] to-[#d98a99]"
                      : "bg-white/10"
                  }`}
                >
                  <Sparkles
                    size={20}
                    className={c.featured ? "text-white" : "text-[#d4af37]"}
                  />
                </div>
                <div className="font-display text-2xl font-semibold leading-tight">
                  {c.name}
                </div>
                <div
                  className={`flex items-center gap-1.5 text-xs mt-2 ${
                    c.featured ? "text-[#b56477]" : "text-white/60"
                  }`}
                >
                  <Clock size={12} /> {c.duration}
                </div>
                <p
                  className={`mt-4 text-sm leading-relaxed flex-1 ${
                    c.featured ? "text-[#5c4642]" : "text-white/70"
                  }`}
                >
                  {c.description}
                </p>
                <div
                  className={`mt-6 font-display text-3xl font-medium ${
                    c.featured ? "text-[#b56477]" : "text-[#d4af37]"
                  }`}
                >
                  ₹{c.price.toLocaleString("en-IN")}
                </div>
                <button
                  onClick={() =>
                    openWhatsApp(bookServiceMessage(c.name, c.price))
                  }
                  data-testid={`enroll-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className={`mt-5 inline-flex items-center justify-center gap-2 w-full px-5 py-3 rounded-full text-sm font-medium ${
                    c.featured ? "btn-rose" : "bg-white text-[#2a1b18] hover:bg-[#d4af37] hover:text-white transition-colors"
                  }`}
                >
                  Enroll Now <ArrowRight size={14} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={300}>
          <div className="mt-12 text-center">
            <button
              onClick={() =>
                openWhatsApp(
                  "Hello Anshi's Makeover! I'd like more details about the Makeup Academy courses, batch timings & fees."
                )
              }
              data-testid="academy-enquire-btn"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-sm font-medium hover:bg-white/15 transition-all"
            >
              <MessageCircle size={16} /> Talk To Us About Your Career
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
